export default {
  'userInvite.title': 'Invite User',
  'userInvite.email': 'Email',
  'userInvite.selectGroup': 'User Group',
  'userInvite.select': 'Select',
  'userInvite.emailHing': 'john.doe@example.com',
  'userInvite.emailHint': 'You can use letters, numbers & periods',
  'userInvite.success': 'User invited successfully!',
};
